<!-- 基地站管理 -->
<template>
  <div class="manufacturer-container">
    <div class="main-container">
      <div class="header-container">
        <div class="left">
          <!-- <div class="tab-btn selected">我的站点</div>
          <div class="tab-btn m-l-10" @click="bindTabItem">人员列表</div> -->
          <el-input v-model="search" size="small" class="w-180" placeholder="名称"></el-input>
          <el-button type="primary" :size="'small'" class="m-l-10" @click="getData">查询</el-button>
        </div>
        <div>
          <el-button type="primary" size="small" @click="addManufacturer">新增</el-button>
        </div>
      </div>
      <div class="table-container">
        <nk-table :columns="columns" :data="tableData" :showPage="true" :page="tablePage" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
          <el-table-column label="地址" slot="address">
            <template slot-scope="scope">
              {{scope.row.address}} <br />{{scope.row.addressDetail}}
            </template>
          </el-table-column>
          <el-table-column label="经纬度" slot="addressPonit">
            <template slot-scope="scope">
              {{scope.row.addressLongitude}},{{scope.row.addressLatitude}}
            </template>
          </el-table-column>
          <el-table-column label="操作" :align="'center'">
            <template slot-scope="scope">
              <el-button type="text" @click="listElectricOperationsWorkBaseMembers(scope.row, scope.$index)">站点成员</el-button>
              <el-button type="text" @click="editStation(scope.$index, scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteStation(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </nk-table>
      </div>
    </div>

    <lt-msg-box :visible="addFormVisible" @cancel="addFormVisible = false" @confirm="saveAddForm" :title="'添加站点'" :width="'500px'">
      <div class="form-container">
        <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="80px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addForm.name" placeholder="请输入站点名称"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-cascader style="width: 100%;" v-model="addForm.address" :props="props" placeholder="请选择省/市/区/街道" :options="options" @change="handler"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="addressDetail">
            <el-input v-model="addForm.addressDetail" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="addressLongitude">
                <el-input v-model="addForm.addressLongitude" placeholder="请输入经度"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" prop="addressLatitude">
                <el-input v-model="addForm.addressLatitude" placeholder="请输入纬度"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="管理员" prop="managerUserId">
                <el-select v-model="addForm.managerUserId" placeholder="请选择管理员">
                  <el-option v-for="item in employees" :key="item.id" :label="item.nickname" :value="item.userId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-row>
        </el-form>
      </div>
    </lt-msg-box>

    <lt-msg-box :visible="editFormVisible" @cancel="editFormVisible = false" @confirm="saveEditForm" :title="'编辑供应商'" :width="'500px'">
      <div class="form-container">
        <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入站点名称"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <p v-show="!editForm.hideAddressSelect">{{editForm.address}} <el-button @click="cutHideAddressSelect" type="text">更改</el-button>
            </p>
            <el-cascader id="cascader" v-if="editForm.hideAddressSelect" style="width: 100%;" v-model="editForm.address" :props="props" placeholder="请选择省/市/区/街道" :options="options" @change="handlerEdit"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="addressDetail">
            <el-input v-model="editForm.addressDetail" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="addressLongitude">
                <el-input v-model="editForm.addressLongitude" placeholder="请输入经度"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" prop="addressLatitude">
                <el-input v-model="editForm.addressLatitude" placeholder="请输入纬度"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="管理员" prop="managerUserId">
                <el-select v-model="editForm.managerUserId" placeholder="请选择管理员">
                  <el-option v-for="item in employees" :key="item.id" :label="item.nickname" :value="item.userId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-row>
        </el-form>
      </div>
    </lt-msg-box>

    <lt-msg-box :visible="stationEmployeesVisible" @cancel="stationEmployeesVisible = false" @confirm="stationEmployeesVisible = false" :title="'站点成员'" :width="'500px'">
      <div style="height:200px;padding: 0px 14px;">
        <el-tag :key="tag.id" v-for="(tag, index) in stationEmployeeFrom.stationEmployees" :closable="tag.id != stationEmployeeFrom.managerUserId" :type="tag.id == stationEmployeeFrom.managerUserId?'success':''" :disable-transitions="false" @close="handleClose(tag, index)">
          {{tag.nickname}}
        </el-tag>
        <el-select v-model="inputValue" style="width:120px" v-if="inputVisible" placeholder="请选择用户" size="small" @change="handleInputConfirm">
          <el-option v-for="item in getEmployeesNoHaveStation()" :key="item.id" :label="item.nickname" :value="item.userId">
          </el-option>
        </el-select>
        <el-button v-else class="button-new-tag" size="small" :disabled="getEmployeesNoHaveStation().length === 0" @click="showAddStationEmployee">+ 添加人员</el-button>
      </div>
    </lt-msg-box>
  </div>
</template>

<script>
import NkTable from '@/components/common/NkTable.vue'
import api from '../../../../../../common/api'
import { toPage } from "@/utils/index";
import LtMsgBox from '@/components/common/LtMsgBox.vue';
import axios from "axios"; // 导入http中创建的axios实例
export default {
  components: { NkTable, LtMsgBox },
  data () {
    //查询百度地址
    var getDress = keywords => {
      let subdistrict = keywords ? "1" : "0";
      return axios.get(
        "https://restapi.amap.com/v3/config/district?key=e5da28e274bdb51b8d07c0073ff4ecd6&keywords=" +
        keywords +
        "&subdistrict=" +
        subdistrict +
        "&extensions=base"
      );
    };

    return {
      search: '',
      columns: [
        { prop: 'name', label: '名称', show: true },
        { slot: 'address', label: '地址', show: true },
        { slot: 'addressPonit', label: '经纬度', show: true },
        { prop: 'managerNickname', label: '管理员', show: true },
      ],
      tableData: [],
      allTableData: [],
      tablePage: {
        pageSizes: [10, 20, 30, 40], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 0,
      },
      options: [],
      props: {
        //配置级联选择器
        label: "name",
        children: "districts",
        value: "name",
        expandTrigger: "hover",
        // checkStrictly: true, //建立级联选择器父子间的关联，从而可以选择任意一级
        lazy: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          let nodes;
          setTimeout(() => {
            getDress(node.label ? node.label : "").then(res => {
              nodes = res.data.districts[0].districts;
              resolve(nodes);
            });
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          }, 100);
        }
      },
      employees: [],
      addFormVisible: false,
      addForm: {},
      addFormRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请选择省/市/区/街道', trigger: 'change' },
        ],
        addressDetail: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        addressLongitude: [
          { required: true, message: '请输入经度', trigger: 'blur' },
        ],
        addressLatitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' },
        ],
        managerUserId: [
          { required: true, message: '请选择管理员', trigger: 'change' },
        ],
      },
      editFormVisible: false,
      editForm: {},
      editFormRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请选择省/市/区/街道', trigger: 'change' },
        ],
        addressDetail: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        addressLongitude: [
          { required: true, message: '请输入经度', trigger: 'blur' },
        ],
        addressLatitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' },
        ],
        managerUserId: [
          { required: true, message: '请选择管理员', trigger: 'change' },
        ],
      },
      stationEmployeesVisible: false,
      stationEmployeeFrom: {},
      inputVisible: false,
      inputValue: null
    }
  },
  created () {
    this.getData(1)
  },
  methods: {
    // bindTabItem () {
    //   this.$emit("tabClick", "personnel")
    // },
    getData (pageIndex) {
      if (!(pageIndex instanceof Number)) {
        pageIndex = 1
      }
      let vm = this
      api.electricOperations.listElectricOperationsWorkBases(0).then(res => {
        let allTableData = []
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].name.indexOf(vm.search) > -1) {
              allTableData.push(res.data[i])
            }
          }
        }
        vm.allTableData = allTableData
        vm.tablePage.pageIndex = pageIndex
        vm.listEmployees()
        vm.getPageData()
      })
    },
    listEmployees () {
      let vm = this
      api.employees.listEmployees(0).then(res => {
        let data = []
        if (res.data) {
          data = res.data
        }
        vm.employees = data
      })
    },
    handleCurrentChange (val) {
      let vm = this
      vm.tablePage.pageIndex = val
      vm.getPageData()
    },
    handleSizeChange (val) {
      let vm = this
      vm.tablePage.size = val
      vm.tablePage.pageIndex = 1
      vm.getPageData()
    },
    getPageData () {
      let vm = this
      const obj = toPage(vm.allTableData, vm.tablePage.pageIndex, vm.tablePage.size)
      vm.tablePage.total = vm.allTableData.length
      vm.tableData = obj.arr
    },
    editStation (index, row) {
      let vm = this
      let obj = JSON.parse(JSON.stringify(row))
      obj.hideAddressSelect = false
      vm.getDress().then(res => {
        vm.options = res.data.districts[0].districts;
        vm.editFormVisible = true
        vm.$nextTick(() => {
          vm.editForm = obj
          vm.$refs['editForm'].clearValidate()
        })
      });
    },
    cutHideAddressSelect () {
      this.editForm.address = this.editForm.address.split('/')
      this.editForm.hideAddressSelect = true
    },
    addManufacturer () {
      let vm = this
      vm.addForm = {}
      vm.getDress().then(res => {
        vm.options = res.data.districts[0].districts;
        vm.addFormVisible = true
        vm.$nextTick(() => {
          vm.$refs['addForm'].clearValidate()
        })
      });
    },

    // 删除基地站
    deleteStation (index, row) {
      let vm = this
      vm.$confirm('此操作将永久删除该站点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.electricOperations.deleteElectricOperationsWorkBase(row.id).then(res => {
          if (res.success) {
            vm.$message("删除成功！")
            vm.getData(vm.tablePage.pageIndex)
          }
        })
      }).catch(() => {
      });
    },

    // 添加站点
    saveAddForm () {
      let vm = this
      vm.$refs['addForm'].validate((valid) => {
        if (valid) {
          const companyId = 0
          let { name, address, addressDetail, addressLongitude, addressLatitude, managerUserId } = vm.addForm
          address = address.join('/')
          api.electricOperations.addElectricOperationsWorkBase(companyId, name, address, addressDetail, addressLongitude, addressLatitude, managerUserId).then(res => {
            if (res.success) {
              vm.$message("添加成功！")
              vm.addFormVisible = false
              vm.getData(vm.tablePage.pageIndex)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 修改站点
    saveEditForm () {
      let vm = this
      vm.$refs['editForm'].validate((valid) => {
        if (valid) {
          let { id, name, address, addressDetail, addressLongitude, addressLatitude, managerUserId, hideAddressSelect } = vm.editForm
          if (hideAddressSelect) {
            address = address.join('/')
          }
          api.electricOperations.modifyElectricOperationsWorkBase(id, name, address, addressDetail, addressLongitude, addressLatitude, managerUserId).then(res => {
            if (res.success) {
              vm.$message("编辑成功！")
              vm.editFormVisible = false
              vm.getData(vm.tablePage.pageIndex)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 选择地址
    handler (value) {
      this.addForm.address = value
    },
    handlerEdit (value) {
      this.editForm.address = value
    },
    //查询百度地址
    getDress () {
      return axios.get(
        "https://restapi.amap.com/v3/config/district?key=e5da28e274bdb51b8d07c0073ff4ecd6&keywords=&subdistrict=1&extensions=base"
      );
    },
    listElectricOperationsWorkBaseMembers (row, index) {
      let vm = this
      api.electricOperations.listElectricOperationsWorkBaseMembers(row.id).then(res => {
        let stationEmployees = []
        if (res.data) {
          stationEmployees = res.data

          for (let i = 0; i < stationEmployees.length; i++) {
            let isManager = false
            if (stationEmployees[i].id == row.managerUserId) {
              isManager = true
            }
            stationEmployees[i].isManager = isManager
          }
        }

        vm.stationEmployeeFrom = {
          stationEmployees: stationEmployees,
          managerUserId: row.managerUserId,
          stationId: row.id
        }
        vm.stationEmployeesVisible = true
        vm.inputVisible = false
      })
    },
    handleClose (item, index) {
      let vm = this
      console.log(index)
      api.electricOperations.removeElectricOperationsWorkBaseMembers(vm.stationEmployeeFrom.stationId, [item.id]).then(res => {
        if (res.success) {
          vm.$message('删除成功！')
          vm.stationEmployeeFrom.stationEmployees.splice(index, 1)
        }
      })
    },
    showAddStationEmployee () {
      this.inputVisible = true
      this.inputValue = null
    },
    // 获取还没有在这个站点的员工列表
    getEmployeesNoHaveStation () {
      let vm = this
      let data = []
      try {
        for (let i = 0; i < vm.employees.length; i++) {
          let isHave = false
          for (let j = 0; j < vm.stationEmployeeFrom.stationEmployees.length; j++) {
            if (vm.stationEmployeeFrom.stationEmployees[j].id == vm.employees[i].userId) {
              isHave = true
              break
            }
          }
          if (!isHave) {
            data.push(vm.employees[i])
          }
        }
      } catch (error) {
        console.log(error)
      }
      return data
    },
    handleInputConfirm () {
      let vm = this
      const item = vm.employees.find(c => c.userId == vm.inputValue)
      api.electricOperations.addElectricOperationsWorkBaseMembers(vm.stationEmployeeFrom.stationId, [vm.inputValue]).then(res => {
        if (res.success) {
          vm.$message('添加成功！')
          vm.stationEmployeeFrom.stationEmployees.push(JSON.parse(JSON.stringify(item)))
          vm.inputVisible = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.manufacturer-container {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .main-container {
    width: 100%;
    height: 100%;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-flow: column;
    .header-container {
      display: flex;
      .left {
        display: flex;
        flex: 1;
      }
    }
    .table-container {
      flex: 1;
      margin-top: 10px;
    }
  }
}
.form-container {
  padding: 0px 14px;
}
.w-180 {
  width: 180px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-t-10 {
  margin-left: 10px;
}
</style>